import React from 'react';
import { MailIconRound } from '@cp/ds/src/icons/social';
import { ButtonProps, ButtonTemplate } from './button';

export const EmailButton = (props: ButtonProps) => (
  <ButtonTemplate {...props}>
    <MailIconRound /> Почта
  </ButtonTemplate>
);
